//import { useSelector } from "react-redux";
import { BillingDataDownloadForm } from "../../../components/BillingDataDownloadForm";
import { BillingDataDownloadRequest } from "../../../gateways/cms/billingData";
//import { billingDataDownload } from "../../../gateways/cms/billingDataDownload";
//import { useDownloadBillingDataQuery } from "../../../gateways/cms/billingRuleApi";
import MainLayout from "../../../layouts/MainLayout";
//import { RootState } from "../../../store";
import { styled } from "@mui/system";

// style
const PageTitle = styled("h1")`
    /* display: flex;
    justify-content: flex-start; */
    padding: 24px;
    // margin-bottom: 16px;
    font-size: 24px;
    font-weight: normal;
    margin: 0 40px 0 0;
`;
const PageContent = styled("section")`
    padding: 0 40px 24px;
`;

export function BillingDataPage() {
    //const token = useSelector((state: RootState) => state.auth.token);
    //const [downloadBilling] = useDownloadBillingDataQuery();
    const download = async (request: BillingDataDownloadRequest) => {
        //const response = await billingDataDownload(token, request);
        //const response = downloadBilling(request);
        //console.log(response);
        /*
        if (response.ok) {
            window.open(URL.createObjectURL(await response.blob()));
        } else {
            alert("error");
        }
        */
    };

    return (
        <MainLayout title="請求データダウンロード">
            <PageTitle>請求データダウンロード</PageTitle>
            <PageContent>
                <BillingDataDownloadForm onSubmit={download} />
            </PageContent>
        </MainLayout>
    );
}
